import { gql } from '@apollo/client';

export const GET_CONTRACT_CUSTOMER_MESSAGE_TEMPLATE = gql`
    query GetContractCustomerMessageTemplate {
        getContractCustomerMessageTemplate {
            chinese
            english
            spanish
            detailMessage
        }
    }
`;

export interface DeliveredContactCustomerTemplateType {
    id: number;
    chinese: string;
    english: string;
    spanish: string;
    detailMessage: string;
}

export interface GetContractCustomerMessageTemplateResponse {
    getContractCustomerMessageTemplate: DeliveredContactCustomerTemplateType[];
}

